import React, { useEffect, useState } from 'react'
import portalServices from '../../app/portalServices';


function CaptchaInput({callBack}) {


    const [captchaImage,setCaptchaImage] =useState(null);
    const [captchaInputText,setCaptchaInputText] = useState("");

    const getCaptchaImage = () =>{
        portalServices.getCaptchaImage().then(res=>{
            setCaptchaImage(res)
        }).catch(error=>{
        })
    }

    useEffect(()=>{
        getCaptchaImage()
    },[])


    useEffect(()=>{
        if(captchaImage){
            if(captchaInputText === ""){
                callBack(null);
            } else {
                callBack({
                    id:captchaImage.captchaId,
                    captchaInputText:captchaInputText
                })
            }
        }
    },[captchaInputText])

    return (
        captchaImage &&
        <div className='row my-2'>
            <div className='col-md-4 text-center'>
                <img src={"data:image/png;base64,"+captchaImage.image}  />
            </div>
            <div className='col-md-8'>
                <input type="text" 
                    className="form-control" 
                    placeholder="Enter the text shown in Image"
                    value={captchaInputText} 
                    onChange={(e)=>setCaptchaInputText(e.target.value)}
                />
            </div>
        </div>
    )
}

export default CaptchaInput


{/*

<div className='col-md-12'>
                <div className="input-group mb-3">
                    <span ><img src={"data:image/png;base64,"+captchaImage.image}  /></span>
                    <input type="text" 
                        className="form-control" 
                        placeholder="Enter the text shown in Image"
                        value={captchaInputText} 
                        onChange={(e)=>setCaptchaInputText(e.target.value)}
                    />
                </div>
            </div>
*/}